// @ts-nocheck


import { DatePicker as AntDatePicker } from 'antd';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';

import { styledDatePicker } from './datePickerStyles';

const DayjsDatePicker = AntDatePicker.generatePicker(dayjsGenerateConfig);

const StyledDatePicker = styledDatePicker(DayjsDatePicker);
const StyledRangePicker = styledDatePicker(DayjsDatePicker.RangePicker);
const StyledMonthPicker = styledDatePicker(DayjsDatePicker.MonthPicker);

export {
  StyledRangePicker as RangePicker,
  StyledDatePicker as DatePicker,
  StyledMonthPicker as MonthPicker };